var RefreshingState;
(function (RefreshingState) {
    RefreshingState[RefreshingState["Enabled"] = 0] = "Enabled";
    RefreshingState[RefreshingState["Unknown"] = 1] = "Unknown";
    RefreshingState[RefreshingState["Disabled"] = 2] = "Disabled";
})(RefreshingState || (RefreshingState = {}));
export default RefreshingState;
